// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 64px;
  border-radius: 6px;
  background-color: var(--light);
  filter: var(--shadow);
  margin: 0 auto;
  max-width: 800px;
}

.Form label {
  margin-top: 8px;
  display: block;
  color: var(--dark);
  font-weight: 600;
}

.Form .inputWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
}

[type="file"] {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}

[type="file"] + label {
  background-color: var(--light);
  border: 3px solid var(--dark);
  color: var(--dark);
  filter: var(--shadow);
  border-radius: 8px;
  
  cursor: pointer;
  display: inline-block;
  padding: 12px 24px;
  min-width: 200px;
  text-align: center;
}

.Form label i {
    font-size: 1.1em;
    margin-left: 8px;
}

.Form .fileName {
    display: inline-block;
    width: fit-content;
    margin-right: 8px;
}

[type="file"]:focus + label,
[type="file"] + label:hover {
    background-color: var(--dark);
    color: var(--light);
    border: 3px solid transparent;
}

[type="file"]:focus + label {
  outline: 1px dotted #000;
}

.Form label {
  align-self: flex-start;
}

.Form textarea {
  height: auto !important;
  max-width: none !important;
  width: 100% !important;
  max-width: 400px !important;
}

@media (max-width: 950px) {
  .Form {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Form.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;;EAElB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,6BAA6B;IAC7B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".Form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 64px;\n  border-radius: 6px;\n  background-color: var(--light);\n  filter: var(--shadow);\n  margin: 0 auto;\n  max-width: 800px;\n}\n\n.Form label {\n  margin-top: 8px;\n  display: block;\n  color: var(--dark);\n  font-weight: 600;\n}\n\n.Form .inputWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 400px;\n}\n\n[type=\"file\"] {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute !important;\n  white-space: nowrap;\n  width: 1px;\n}\n\n[type=\"file\"] + label {\n  background-color: var(--light);\n  border: 3px solid var(--dark);\n  color: var(--dark);\n  filter: var(--shadow);\n  border-radius: 8px;\n  \n  cursor: pointer;\n  display: inline-block;\n  padding: 12px 24px;\n  min-width: 200px;\n  text-align: center;\n}\n\n.Form label i {\n    font-size: 1.1em;\n    margin-left: 8px;\n}\n\n.Form .fileName {\n    display: inline-block;\n    width: fit-content;\n    margin-right: 8px;\n}\n\n[type=\"file\"]:focus + label,\n[type=\"file\"] + label:hover {\n    background-color: var(--dark);\n    color: var(--light);\n    border: 3px solid transparent;\n}\n\n[type=\"file\"]:focus + label {\n  outline: 1px dotted #000;\n}\n\n.Form label {\n  align-self: flex-start;\n}\n\n.Form textarea {\n  height: auto !important;\n  max-width: none !important;\n  width: 100% !important;\n  max-width: 400px !important;\n}\n\n@media (max-width: 950px) {\n  .Form {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
